const upload = {
    id: `upload-${Math.random()}`,
    title: 'Upload',
    type: 'item',
    url: `/report/upload`,
    // icon: icons.IconReport,
    breadcrumbs: false,
    // children: transChild,
    role: process.env.REACT_APP_RL_GENREPCOL
};

export default upload;